import { apiClient } from "./apiClient";

export const shareLinkApi = {
  list: (clientId) => apiClient.get(`/clients/${clientId}/share-links`).then((r) => r.data),
  generate: (clientId, expiresInDays) => apiClient.post(`/clients/${clientId}/share-links`, { expires_in_days: expiresInDays }).then((r) => r.data),
  revoke: (clientId, linkId) => apiClient.post(`/clients/${clientId}/share-links/${linkId}/revoke`).then((r) => r.data),
};
